import React, { useState, useEffect } from "react";
import { Table, Row, Col, Button, Form } from "react-bootstrap";

export default function CustomConversions(props) {
  const [customConversions, setCustomConversions] = useState(props.customConversions && props.customConversions.length > 0 ? props.customConversions : [{label: "", id: ""}]);
  const handleChange = (index, property, value) => {
    let newConversions = customConversions;
    newConversions[index][property] = value;
    setCustomConversions([...newConversions])
    props.setCustomConversions && props.setCustomConversions([...newConversions])
  }

  const handleDelete = (targetIndex) => {
    let newConversions = customConversions
    newConversions.splice(targetIndex, 1);
    setCustomConversions([...newConversions])
    props.setCustomConversions && props.setCustomConversions([...newConversions])
  }

  const handleAdd = () => {
    setCustomConversions([...customConversions, {label: "", id: ""}])
    props.setCustomConversions && props.setCustomConversions([...customConversions, {label: "", id: ""}])
  }

  return (
    <>
      <Table className="overflow-hidden">
        <thead>
          <tr>
            <td className="pl-3 f12 primary">Label</td>
            <td className="pl-3 f12 primary">ID</td>

            <td></td>
          </tr>
        </thead>
        <tbody>
          {customConversions.map((conversion, index) => {
            return (
              <tr key={index}>
                <td className="pl-1" style={{ width: "180px" }}>
                  <Form.Control
                    size="sm"
                    value={conversion["label"]}
                    name={`[facebook_custom_conversions][${index}][label]`}
                    onChange={(e) => handleChange(index, "label", e.target.value)}
                  />
                </td>
                <td style={{ width: "180px" }}>
                  <Form.Control
                    size="sm"
                    value={conversion["id"]} 
                    name={`[facebook_custom_conversions][${index}][id]`}
                    onChange={(e) => handleChange(index, "id", e.target.value)}
                  />
                </td>
                <td>
                  {index >= 1 && (
                    <i className=" pl-2 fas fa-minus-circle" onClick={(e) => handleDelete(index)}></i>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Button
        className="my-2 ml-1"
        style={{ paddingLeft: "30px", paddingRight: "30px" }}
        variant="success"
        onClick={handleAdd}
      >
        + Add custom conversion
      </Button>
    </>
  )
}
